var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":_vm.$t('dangerousGoods.dangerousGoodsList.form.identifier'),"rules":_vm.rules,"data-cy":"identifier"},model:{value:(_vm.value.identifier),callback:function ($$v) {_vm.$set(_vm.value, "identifier", $$v)},expression:"value.identifier"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }